import api from '../../api/restaurant/restaurantRawMaterialIdentifierApi';
import {
  CustomResponse,
  ResolveRawMaterialIdentifierRequest,
  ResolvedRawMaterial,
  RestaurantRawMaterialIdentifierDTO,
  RestaurantRawMaterialIdentifierForm,
} from '../../types/restaurant/RestaurantRawMaterialIdentifierTypes';
import {
  RawMaterialIdentifierBatchResolveRequest,
  RawMaterialIdentifierBatchResolveRow,
} from '../../types/restaurant/RestaurantDteImportTypes';

const body = (form: RestaurantRawMaterialIdentifierForm) => ({
  supplierId: form.supplierId === '' ? null : Number(form.supplierId),
  type: form.type,
  value: form.value.trim(),
});

const RestaurantRawMaterialIdentifierService = {
  list: async (rawMaterialId: number) =>
    (await api.fetchCustom(`/raw-materials/${rawMaterialId}`)).data as CustomResponse<RestaurantRawMaterialIdentifierDTO[]>,
  create: async (rawMaterialId: number, form: RestaurantRawMaterialIdentifierForm) =>
    (await api.addCustom(`/raw-materials/${rawMaterialId}`, body(form))).data as CustomResponse<RestaurantRawMaterialIdentifierDTO>,
  update: async (id: number, form: RestaurantRawMaterialIdentifierForm) =>
    (await api.modify(id, body(form))).data as CustomResponse<RestaurantRawMaterialIdentifierDTO>,
  updateActive: async (id: number, active: boolean) =>
    (await api.patchCustom(`${id}/active`, { active })).data as CustomResponse<RestaurantRawMaterialIdentifierDTO>,
  remove: async (id: number) =>
    (await api.remove(id)).data as CustomResponse<null>,
  resolve: async ({ branchId, supplierId, type, value }: ResolveRawMaterialIdentifierRequest) => {
    const query = new URLSearchParams({ type, value });
    if (supplierId !== null) query.set('supplierId', String(supplierId));
    return (await api.fetchCustom(`/branches/${branchId}/resolve?${query.toString()}`)).data as CustomResponse<ResolvedRawMaterial>;
  },
  resolveBatch: async (
    branchId: number,
    payload: RawMaterialIdentifierBatchResolveRequest
  ) =>
    (await api.addCustom(`/branches/${branchId}/resolve-batch`, payload))
      .data as CustomResponse<RawMaterialIdentifierBatchResolveRow[]>,
};

export default RestaurantRawMaterialIdentifierService;
